var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgCategoryBuilding = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 1.524,
    d: "M24.8 48.8c13.255 0 24-10.745 24-24S38.055.8 24.8.8s-24 10.745-24 24 10.745 24 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 28.3h-.9v1.8h.9zM16.4 28.3h-.9v1.8h.9zM8.7 24.7h-.9v1.8h.9zM16.4 24.7h-.9v1.8h.9zM13.8 24.7h-.9v1.8h.9zM11.3 24.7h-.9v1.8h.9zM8.7 21.1h-.9v1.8h.9zM16.4 21.1h-.9v1.8h.9zM13.8 21.1h-.9v1.8h.9zM22.7 21.1h-.9v1.8h.9zM24.5 21.1h-.9v1.8h.9zM11.3 21.1h-.9v1.8h.9zM10.3 33.7h.9v-4.5h1.7v4.5h.9v-5.4h-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7 16.1H29.6v.9h1.1v3.9h-4.4v6.8l.9.9v-6.9h3.5v12.8H18.6V31l2-2.2 2 2.2 2-2.2 2 2.2 2-2.2 1.2 1.3V29l-1.2-1.3-2 2.2-2-2.2-2 2.2v-5.3h2.2v-.9h-3.1V29l-1.1-1.3-2 2.2V19.3h.9v-.9H4.7v.9h.9v16.2h38V17h1.1zM6.5 34.6V19.3h11.3v15.3zm36.2 0H31.5V17h11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 28.3h-.9v1.8h.9zM41.4 28.3h-.9v1.8h.9zM33.7 24.7h-.9v1.8h.9zM41.4 24.7h-.9v1.8h.9zM38.8 24.7h-.9v1.8h.9zM36.3 24.7h-.9v1.8h.9zM33.7 21.1h-.9v1.8h.9zM41.4 21.1h-.9v1.8h.9zM38.8 21.1h-.9v1.8h.9zM36.3 21.1h-.9v1.8h.9zM33.7 18.5h-.9v.9h.9zM41.4 18.5h-.9v.9h.9zM38.8 18.5h-.9v.9h.9zM36.3 18.5h-.9v.9h.9zM36.2 29.2h1.7v4.5h.9v-5.4h-3.5v5.4h.9zM24.8 17.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.8 15.5 1.4-.8c-.6-1.9-2.3-3.2-4.4-3.2s-3.8 1.4-4.4 3.2l1.4.8c.3-1.4 1.5-2.5 3-2.5s2.8 1 3 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 10.2c2.5 0 4.7 1.6 5.5 3.8l1.2-.7c-1.1-2.6-3.7-4.5-6.7-4.5s-5.6 1.9-6.7 4.5l1.2.7c.9-2.2 3-3.8 5.5-3.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h49.5v49.5H0z"
  })))));
};
const Memo = /*#__PURE__*/memo(SvgCategoryBuilding);
export default Memo;